import LendingAccountSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingAccountSettings';
import EntityIdentifier from "@/models/Shared/EntityIdentifier";
import ProductMigrationState from '@/models/Products/ProductMigrations/ProductMigrationState';
import LendingAccountPaymentInterface from "@/models/Accounts/LendingAccounts/LendingAccountPaymentInterface";
import AccountState from "@/models/Accounts/Shared/AccountState";
import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";
import ProductType from "@/models/Products/ProductType";
import ProductSubType from '@/models/Products/ProductSubType';
import Amount from "@/models/Shared/Amount";

export default class LendingAccount {
    accountNumber: string;
    accountSettings: LendingAccountSettings;
    accountStateReasonCode: string;
    accountStateReasonDescription: string;
    availableBalance: Amount;
    balance: Amount;
    createdAt: string;
    currentTestDateUtc: Date;
    customerId: string;
    customerIdentifier: EntityIdentifier;
    defaultCurrency: string;
    enabled: boolean;
    id: string;
    lastSuccessfulMigrationId: string;
    lastSuccessfulMigrationIdentifier: EntityIdentifier;
    migrationStatus: ProductMigrationState;
    name: string;
    nextMigrationId: string;
    nextMigrationIdentifier: EntityIdentifier;
    paymentInterfaces: LendingAccountPaymentInterface[] = [];
    productType: ProductType;
    productId: string;
    productIdentifier: EntityIdentifier
    productIssueId: string;
    productIssueIdentifier: EntityIdentifier
    productSubType: ProductSubType;
    reviewDateUtc: Date;
    state: AccountState;
    updatedAt: string;
    // Is this going to be called ledgers in the future or just wallets?
    // If it is going to stay as wallets, move the wallet model into shared/ otherwise update this
    wallets: Wallet[] = [];
}